/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/accordion/custom-elements';

import { defineCustomElement as defineOsdsAccordion } from '@ovhcloud/ods-stencil/components/accordion/custom-elements/osds-accordion.js';
import { defineCustomElement as defineOsdsAccordionGroup } from '@ovhcloud/ods-stencil/components/accordion/custom-elements/osds-accordion-group.js';

export const OsdsAccordion = /*@__PURE__*/createReactComponent<JSX.OsdsAccordion, HTMLOsdsAccordionElement>('osds-accordion', undefined, undefined, defineOsdsAccordion);
export const OsdsAccordionGroup = /*@__PURE__*/createReactComponent<JSX.OsdsAccordionGroup, HTMLOsdsAccordionGroupElement>('osds-accordion-group', undefined, undefined, defineOsdsAccordionGroup);
